module.exports = "<p>\n  <button (click)=\"userService.logout()\">logout</button>\n</p>\n"